module.exports = __webpack_public_path__ + "static/media/24UHCHR12.3e681c1e.jpg";